import { Component, Element, Host, h } from '@stencil/core';

/**
 * Component for displaying a value in a chart tooltip, should be used within an `aha-chart-tooltip`.
 * @slot default - Description of value. Include the value here if you don't need it to be right aligned
 * @slot icon - Icon for the tooltip value, typically an `aha-icon` element.
 * @slot value - Right aligned value
 */
@Component({
  tag: 'aha-chart-tooltip-value',
  styleUrl: 'aha-chart-tooltip-value.css',
  shadow: true,
})
export class AhaChartTooltipValue {
  @Element() host!: HTMLAhaChartTooltipValueElement;

  render() {
    return (
      <Host>
        <slot name="icon"></slot>
        <slot></slot>
        <slot name="value"></slot>
      </Host>
    );
  }
}
